/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum VestingTermType {
    STRAIGHT_LINE = 'STRAIGHT_LINE',
    GRADED = 'GRADED',
}
